/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_NewInputs */

const vi_phase_new = /** @type {(inputs: Phase_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm giai đoạn`)
};

/**

* @param {Phase_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const phase_new = /** @type {((inputs?: Phase_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_phase_new(inputs)
});